<template>
  <div class="popup-wrapper" @click.self="action.close">
    <div class="popup-action">
      <div class="button button-close">
        <button class="btn" @click="action.close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">パーツの追加</span>
          <!-- <span class="popup-title-sub">パーツの追加に対する注記が記載されます。</span> -->
        </div>
        <div class="popup-content">
          <ul class="popup-content-list">
            <li @click="action.addText" class="popup-content-list-item">
              見出し
            </li>
            <li @click="action.addTextarea" class="popup-content-list-item">
              コメント
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'SPNotePartAdd',
  setup (props, context) {
    const action = reactive({
      close: () => context.emit('close'),
      addText: () => context.emit('addText'),
      addTextarea: () => context.emit('addTextarea')
    })

    return {
      action
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    &-list {
      &-item {
        border-bottom: 1px solid $color-line;
        color: $color-link;
        font-size: 1.6rem;
        padding: 20px 16px;
      }
    }
  }
  &-action {
    width: auto;
    left: auto;
    right: 0;
    border-top-left-radius: 8px;
    .btn {
      height: 78px;
    }
  }
}


</style>
